import React from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

const DetailsDropdown = ({ activeTab = "overview", onChange, tabs }) => {
  const dropdownOptions = tabs.map((tab) => ({
    value: tab.id,
    label: tab.label,
  }));

  return (
    <>
      <ul className="tabs d-none d-sm-block">
        {tabs.map((tab) => (
          <li
            key={tab.id}
            className={tab.id === activeTab ? "active" : ""}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </li>
        ))}
      </ul>

      <div className="d-sm-none mx-2 contact-details-dropdown mt-4">
        <Dropdown
          options={dropdownOptions}
          onChange={(o) => onChange(o.value)}
          value={activeTab}
          defaultValue={activeTab}
        />
      </div>
    </>
  );
};

export default DetailsDropdown;
